export default {
  "build": true,
  "bundler": "webpack",
  "cache": true,
  "watch": true,
  "name": "Whole Body App",
  "plugins": [
    {},
    {}
  ]
}